module.exports = __webpack_public_path__ + "img/ico_survey_home.b5c4ea70.svg";